<template>

        <div class="box content is-small" style="margin-top: 10px; margin-right: 10px">

            <strong> Search By : </strong>
            <b-taglist>
                <b-tag type="is-light" v-if="dataToChild.date_selected.length>0" >{{ dataToChild.date_selected }}</b-tag>
                <b-tag type="is-light" v-if="dataToChild.opd_no.length>0">{{ dataToChild.opd_no }}</b-tag>
                <b-tag type="is-light" v-if="dataToChild.opd_name.length>0" >{{ dataToChild.opd_name }}</b-tag>
                <b-tag type="is-light" v-if="dataToChild.owner_name.length>0" >{{ dataToChild.owner_name }}</b-tag>
                <b-tag type="is-dark">Found records</b-tag>
                <b-tag type="is-dark"> {{ dataToChild.number_of_rec_found }} </b-tag>
            </b-taglist>





        </div>


</template>

<script>
    export default {
        name: "SearchBy",
        props:{
            dataToChild : Object
        }
    }
</script>

<style scoped>

</style>